import { Typography, Grid, Stack } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useContext, useState } from 'react';
import { useSnackbar } from 'notistack';
import { getErrorMessage } from '../../Shared/errorHandling';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext
} from '../../WorkflowEngine/workflowEngineReducer';
import { post } from '../../Shared/ajax';
import ReadOnlyFooterEditButton from './ReadOnlyFooterEditButton';

const ReadOnlyFooter = () => {
  const { state, dispatch } = useContext(WorkflowEngineContext);

  const { versionExternalId } = state;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { enqueueSnackbar } = useSnackbar();

  const switchToEditMode = (versionExternalId: string) => {
    dispatch({
      type: WorkflowEngineActionKind.SWITCH_TO_EDIT_MODE,
      payload: versionExternalId
    });
  };

  const handleEditClick = async () => {
    setIsLoading(true);
    try {
      const url = `DynamicWorkflowVersion/${versionExternalId}`;
      const response = await post<
        {
          versionExternalId: string;
        },
        undefined
      >(url, undefined);
      switchToEditMode(response.versionExternalId);
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: 'error' });
    }
    setIsLoading(false);
  };

  return (
    <div
      style={{
        backgroundColor: '#F7EDC3',
        opacity: 0.75,
        width: '100%',
        height: '50px',
        position: 'fixed',
        bottom: '0px'
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        sx={{ height: '100%' }}
      >
        <Grid item xs={12} md={3}></Grid>
        <Grid item xs={12} md={6}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <LockIcon fontSize="small" sx={{ marginRight: 2 }} />
            <Typography variant="body2">PUBLISHED WORKFLOW</Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={3}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <ReadOnlyFooterEditButton
              disabled={isLoading}
              onClick={handleEditClick}
            />
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default ReadOnlyFooter;
